import React from 'react'
import Card from '../../components/Basics/InfoCard.container'
import Link from '../../components/Basics/Link.container';
import { Root, Separator } from './Dashboard.styles'
import routes from '../../config/settings/routes';
import { ChoroplethMap, Report, ListBoxes, SummaryKpi, Map, ListBulleted, ChartMultitype } from '@carbon/icons-react';
import Typography from '../../components/Basics/Typography';
import { Stack } from "@carbon/react";
import { g100 } from '@carbon/themes';

const DashboardBody = () => {
  return (
    <Stack gap={3}>
      <Typography
        className='cds--type-body-01'
        color={g100.textHelper}
        justify='space-between'
        display='flex'
        $margin="8px 0 0 0"
      >
        Módulos Principales
      </Typography>
      <Separator />
      <Root>

            <Link route={routes.map} display='inline-flex'>
              <Card
                icon={<ChoroplethMap size={32} />}
                title='Mapa'
                footer='Mapa en tiempo real con información de la señal GPS de los equipos. También permite ver las zonas de trabajo.'
              />
            </Link>

            <Link route={routes.canDashboard} display='inline-flex'>
              <Card
                icon={<SummaryKpi size={32} />}
                title='Dashboard CAN'
                footer='Panel con información de parámetros ECU del equipo y recorrido del equipo.'
              />
            </Link>

            {/* <Link route={routes.ordersOrder} display='inline-flex'>
              <Card
                icon={<ListBoxes size={32} />}
                title='Ordenes de Trabajo'
                footer='Una vista con una tabla que muestra el estado de las órdenes de trabajo, actualizada regularmente a lo largo del turno.'
              />
            </Link>

            <Link route={routes.reportsReport} display='inline-flex'>
              <Card
                icon={<Report size={32} />}
                title="Reportes"
                footer='Una vista con una tabla que presenta el avance de las órdenes de trabajo y los tiempos del reporte de manera frecuente durante el transcurso del turno.'
              />
            </Link> */}

            <Link route={routes.cyclesCycles} display='inline-flex'>
              <Card
                icon={<ListBulleted size={32} />}
                title="Ciclos"
                footer='Una vista con 2 tablas orientadas a manejar información asociada a los orígenes y destinos para gestionar la detección de ciclos.'
              />
            </Link>

            <Link route={routes.timesTimes} display='inline-flex'>
              <Card
                icon={<ChartMultitype size={32} />}
                title="Disponibilidad y utilización"
                footer='Una vista con el detalle de tiempos clave en turnos pasados.'
              />
            </Link>

            <Link route={routes.huellaDashboard} display='inline-flex'>
              <Card
                icon={<Map size={32} />}
                title="Vista Individual de Movimientos Recientes"
                footer='Consulte de forma individual los recorridos y la velocidad de los equipos en los últimos 7 días.'
              />
            </Link>

            <Link route={routes.kepler} display='inline-flex'>
              <Card
                icon={<Map size={32} />}
                title="Vista Consolidada de movimientos Históricos"
                footer='Revise y explore la información histórica de movimientos de todos los equipos por fecha.'
              />
            </Link>

      </Root>
    </Stack>
  )
}

export default DashboardBody
